import InputAdornment from './InputAdornment';

export default InputAdornment;
